import { ValidatorFn, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Guid } from 'guid-typescript';
// @dynamic
export class FormsHelper {

  public static TranslateValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      
      var v = (typeof control.value === 'object' && 'textInCurrentLanguage' in control.value) ? null : { "format": true };

      if (v== null)
      {
        if (control.value.id != Guid.EMPTY)
        {
          return null;
        }
        else{
          return {"value":true}
        } 
      }
      else
      {
        return v;
      } 
      
    };
  }

  public static CustomValidateCheckboxArray(field: string): ValidatorFn {
    return (formArray: FormArray): { [key: string]: any } | null => {
      let checked: number = 0;
 
      formArray.controls.forEach((x: FormControl) => {
        if (x.value[field]) {
          checked++;
        }
      })
      return checked > 0 ? null : { error: 'At least one selection needed' }
    }
  }; 
}
